import BaseService from "./base.js";

class VarzService {
  get() {
    return BaseService.get("/api/varz");
  }
}

module.exports = new VarzService();
